import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="emq-drawer"
// Switches visible panel inside a single DrawerComponent.
// Each "View Details" button passes an index param to show the
// matching panel and hide the rest (header + body panels together).
export default class extends Controller {
  static targets = ["panel"]

  select({ params: { index } }) {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.index !== String(index))
    })

    // Reset drawer tabs back to Summary when switching CAs
    const tabsEl = this.element.querySelector("[data-controller~='drawer-tabs']")
    if (tabsEl) {
      const tabsController = this.application.getControllerForElementAndIdentifier(tabsEl, "drawer-tabs")
      if (tabsController) tabsController.reset()
    }
  }
}
